<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-12">
                <div class="card-title">
                    <h4>Activity</h4>
                </div>
                <ms-audit-logs [entityId]="user()?.userId" [entityType]="AuditEntityType.User"></ms-audit-logs>
            </div>
        </div>
    </div>
</div>